import { createI18n } from "vue-i18n";
import uk from "./locales/uk";
import ru from "./locales/ru";
import en from "./locales/en";

export const DEFAULT_LOCALE = "uk";
export const SUPPORTED_LOCALES = ["uk", "ru", "en"];
export const SWITCHABLE_LOCALES = ["uk", "en"];
export const LOCALE_STORAGE_KEY = "app_locale";

const LOCALE_TAGS = {
  uk: "uk-UA",
  ru: "ru-RU",
  en: "en-US"
};

function canUseBrowserApi() {
  return typeof window !== "undefined";
}

function normalizeLocale(locale) {
  if (!locale || typeof locale !== "string") {
    return DEFAULT_LOCALE;
  }
  const shortLocale = locale.toLowerCase().split("-")[0];
  return SUPPORTED_LOCALES.includes(shortLocale) ? shortLocale : DEFAULT_LOCALE;
}

function normalizeSwitchableLocale(locale) {
  const normalizedLocale = normalizeLocale(locale);
  return SWITCHABLE_LOCALES.includes(normalizedLocale)
    ? normalizedLocale
    : DEFAULT_LOCALE;
}

function resolveInitialLocale() {
  if (!canUseBrowserApi()) {
    return DEFAULT_LOCALE;
  }
  const storedLocale = normalizeSwitchableLocale(
    localStorage.getItem(LOCALE_STORAGE_KEY)
  );
  if (
    storedLocale !== DEFAULT_LOCALE ||
    localStorage.getItem(LOCALE_STORAGE_KEY)
  ) {
    return storedLocale;
  }
  return normalizeSwitchableLocale(navigator.language);
}

function readLocale(globalLocale) {
  return typeof globalLocale === "string" ? globalLocale : globalLocale.value;
}

export function getLocaleTag(locale) {
  return LOCALE_TAGS[normalizeLocale(locale)] || LOCALE_TAGS[DEFAULT_LOCALE];
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: resolveInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    uk,
    ru,
    en
  }
});

export function getCurrentLocale() {
  return normalizeLocale(readLocale(i18n.global.locale));
}

export function setI18nLocale(locale) {
  const normalizedLocale = normalizeSwitchableLocale(locale);
  if (typeof i18n.global.locale === "string") {
    i18n.global.locale = normalizedLocale;
  } else {
    i18n.global.locale.value = normalizedLocale;
  }
  if (canUseBrowserApi()) {
    localStorage.setItem(LOCALE_STORAGE_KEY, normalizedLocale);
  }
  return normalizedLocale;
}
